module.exports = __webpack_public_path__ + "static/bouweceunen.resume-4fa35880b2f5ffb7eedb9df8fb7e4766.pdf";